/**
 * @author Tommy Brière
 * @copyright (c) 2013 Groupe PVP
 * @fileoverview Common code for loaders
 *     global constants
 *  common functions
**/
(function($, $g) {
    
    function Loader() {
        var me = this;
        this.items = {};
        
        /**
         * short cut to this.items
         * @param id string
         * @return    undefined of new items,    true for in loading or no usable data, the loaded content if available
         */
        this.get = function(id) {
            return me.items[id];
        };
        
        /**
         * Load a ressource
         * Alway says the file is already loaded
         * @return Loader.NOT_NEW
         */
        this.load = function() {
            return Loader.NOT_NEW;
        };
        
        /**
         * Unload items that are no more needed
         * @param actId
         * @return undefined
         */
        this.unload = function(actId) {
        	
        };
    }
    
    Loader.ACCEPTED = 0;
    Loader.BUSY = 1;
    Loader.NOT_NEW = 2;
    
    Loader.COMPLETE = "complete";
    Loader.FAILED = "failed";
    
    $g.Loader = Loader;
    
})(jQuery, PVPGEngine);